import { Img } from 'openimg/react'
import { Link, Form } from 'react-router'
import { ThemeToggle } from '#app/routes/resources/theme-switch.tsx'
import { getUserImgSrc } from '#app/utils/misc.tsx'
import { useRequestInfo } from '#app/utils/request-info.ts'
import { useUser } from '#app/utils/user.ts'
import { Button } from './ui/button'
import { Icon } from './ui/icon'
import { Separator } from './ui/separator'
import {
	Sheet,
	SheetClose,
	SheetContent,
	SheetTitle,
	SheetTrigger,
} from './ui/sheet'

export function UserDropdown() {
	const user = useUser()
	const requestInfo = useRequestInfo()
	return (
		<Sheet>
			<SheetTrigger asChild>
				<Button variant='default' className='flex items-center gap-2'>
					<span className='font-medium'>{user.name ?? user.username}</span>
					<Img
						className='size-9 rounded-full object-cover'
						alt={user.name ?? user.username}
						src={getUserImgSrc(user.image?.objectKey)}
						width={256}
						height={256}
						aria-hidden='true'
					/>
				</Button>
			</SheetTrigger>
			<SheetContent side='right' className='flex max-w-sm flex-col'>
				<SheetTitle className='sr-only'>Mon compte</SheetTitle>

				<div className='flex flex-col items-center gap-3 px-6 pt-10 pb-6'>
					<Img
						className='size-20 rounded-full object-cover'
						alt={user.name ?? user.username}
						src={getUserImgSrc(user.image?.objectKey)}
						width={512}
						height={512}
					/>
					<p className='text-lg font-semibold'>{user.name ?? user.username}</p>
				</div>

				<Separator />

				<nav className='flex flex-col gap-1 p-4'>
					<SheetClose asChild>
						<Link
							to='/settings/profile'
							className='hover:bg-accent/50 flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors'
						>
							<Icon name='pencil-1' />
							Modifier votre compte
						</Link>
					</SheetClose>
					<SheetClose asChild>
						<Link
							to='/settings/profile?section=change-email'
							className='hover:bg-accent/50 flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors'
						>
							<Icon name='envelope-closed' />
							Modifier votre courriel
						</Link>
					</SheetClose>
					<SheetClose asChild>
						<Link
							to='/settings/profile?section=password'
							className='hover:bg-accent/50 flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors'
						>
							<Icon name='lock-closed' />
							Changer votre mot de passe
						</Link>
					</SheetClose>
				</nav>

				<Separator />

				<div className='p-4'>
					<p className='text-muted-foreground mb-3 text-sm font-medium'>
						Apparence
					</p>
					<ThemeToggle userPreference={requestInfo.userPrefs.theme} />
				</div>

				<div className='mt-auto p-4'>
					<Separator className='mb-4' />
					<Form action='/logout' method='POST'>
						<Button
							type='submit'
							variant='outline'
							className='w-full justify-center'
						>
							<Icon name='exit'>Déconnexion</Icon>
						</Button>
					</Form>
				</div>
			</SheetContent>
		</Sheet>
	)
}
